/** Пробелы, переносы и инлайн-разметка, которыми редактор рвёт метку в ячейке таблицы. */
const HTML_GAP =
    '(?:\\s|\\u00A0|\\u200B|&nbsp;|&#160;|<br\\s*/?>|</?(?:span|font|b|i|u|strong|em|p)[^>]*>)*'

/** Схлопывает переносы, nbsp и нулевые пробелы из вставленного {{keyword}}. */
export function normalizeEntityKeyword(raw: string): string {
    if (!raw) {
        return ''
    }
    return raw
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/&nbsp;|&#160;/gi, ' ')
        .replace(/[\s\u00A0\u202F\u2007]+/g, ' ')
        .trim()
}

/** Метка, которую вставляют в текст договора: {{Сумма}}. */
export function entityTextMarker(keyword?: string | null): string {
    const name = normalizeEntityKeyword(String(keyword ?? ''))
    return name ? `{{${name}}}` : '{{Название поля}}'
}

export function entityMarkerIntoTextHint(keyword?: string | null): string {
    return `Поле появится в договоре только там, где в тексте стоит метка ${entityTextMarker(keyword)}. Скопируйте её и вставьте в нужное место.`
}

export function keywordFromRawMarkerInner(inner: string): string {
    const text = inner
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/&nbsp;|&#160;/gi, ' ')
        .replace(/<[^>]+>/g, ' ')
    return normalizeEntityKeyword(text)
}

function escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function entityInnerFlexiblePattern(keyword: string): string {
    const tokens = keyword.trim().split(/\s+/).filter(Boolean).map(escapeRegExp)
    if (tokens.length === 0) {
        return ''
    }
    return tokens.join(HTML_GAP)
}

function markerAlternatives(inner: string, checkRaw: boolean): string {
    const named = `<<${inner}>>|&lt;&lt;${inner}&gt;&gt;`
    if (!checkRaw) {
        return named
    }
    return `\\{\\{${inner}\\}\\}|${named}`
}

export function entityMarkerFlexibleRe(keyword: string, checkRaw: boolean = false): RegExp | null {
    const inner = entityInnerFlexiblePattern(keyword)
    if (!inner) {
        return null
    }
    return new RegExp(markerAlternatives(inner, checkRaw))
}

export function findNextRawEntityMarker(
    html: string,
    keyword: string,
    fromIndex: number = 0,
): { index: number, length: number } | null {
    const inner = entityInnerFlexiblePattern(keyword)
    if (!inner || !html) {
        return null
    }
    const re = new RegExp(`\\{\\{${inner}\\}\\}`, 'g')
    re.lastIndex = fromIndex
    const match = re.exec(html)
    if (!match) {
        return null
    }
    return { index: match.index, length: match[0].length }
}

export function isEntityMarkerInHtml(keyword: string, html: string, checkRaw: boolean = false): boolean {
    if (!keyword?.trim() || html == null) {
        return false
    }
    const re = entityMarkerFlexibleRe(keyword, checkRaw)
    if (!re) {
        return false
    }
    return re.test(html)
}

/** Демо-префилл: true/false по метке в HTML; null — смотреть hidden. Не для живой формы. */
export function htmlRequestsClientPassport(body?: string | null): boolean | null {
    if (!body) {
        return null
    }
    if (isEntityMarkerInHtml('Паспорт клиента', body, true)) {
        return true
    }
    if (body.includes('{{Паспорт}}') || body.includes('{{Паспортные данные}}')) {
        return null
    }
    if (body.includes('{{') || body.includes('name="')) {
        return false
    }
    return null
}
